import { FormattedMessage } from 'react-intl';

import { LogService } from '../../../services/log-service';

/**
 * @param {Record<string, import('../../../prop-types/intl').MessageDescriptorPropType>} messages
 * @param {import('../data/types/import-type').ImportTypes} importType
 * @returns {(shipstationField: string) => React.ReactNode}
 */
export const getTranslationFn = (messages, importType) => {
  return (shipstationField) => {
    const message = messages[shipstationField];
    if (!message) {
      LogService.logInfo(`CSV Import ${importType} Error - Unable to find message for field: ${shipstationField}`, {
        importType,
        shipstationField,
      });
      return shipstationField;
    }
    return <FormattedMessage {...message} />;
  };
};
